<template>
    <div>
        <div>
            <geo-editor-component
              style="height: 500px;"
              ref="geoEditor"
              :mode="mode"
              v-model="geo_json_editable"
              v-on:update:value="geo_json_editable = $event"
              :background-layer="geo_json_background"
            />
        </div>
        <div class="p-3 border-top">
            <div v-if="mode === 'show'" class="text-right">
                <b-button variant="primary" size="sm" @click="mode = 'edit'">
                    <span class="far fa-edit fa-fw"></span>
                    Изменить
                </b-button>
            </div>
            <div v-else-if="mode === 'edit'" class="d-flex justify-content-between">
                <b-button variant="light" size="sm" @click="cancelEdit">
                    <span class="far fa-chevron-left fa-fw"></span>
                    Отмена
                </b-button>
                <b-button variant="success" size="sm" @click="saveData">
                    <span class="far fa-check fa-fw"></span>
                    Сохранить
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            mode: 'show',
            geo_json: null,
            geo_json_editable: null,
            geo_json_background: null,
            url: process.env.VUE_APP_API_ROOT + '/api/projects_other/' + this.$route.params.id + '/map'
        }
    },
    methods: {
        fetchData () {
            this
                .$http
                .get(this.url)
                .then(res => {
                    this.geo_json = res.data.geo_json
                    this.geo_json_editable = res.data.geo_json
                    this.geo_json_background = res.data.geo_json_background
                })
        }, 
        saveData () {
            this
                .$http
                .post(this.url, {
                    'geo_json': this.geo_json_editable
                })
                .then(res => {
                    this.geo_json = res.data.geo_json
                    this.geo_json_editable = res.data.geo_json
                    this.geo_json_background = res.data.geo_json_background
                    this.$notify({
                        group: 'main',
                        text: 'Обновлено!',
                        type: 'alert-success'
                    })
                    this.mode = 'show'
                })

        },
        cancelEdit () {
            this.mode = 'show'
            this.geo_json_editable = this.geo_json
        }
    },
    mounted () {
        this.fetchData()
    }
}
</script>